var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10392_3950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.66539C0.5 2.02188 0.725232 1.49099 1.17568 1.07273C1.62612 0.654444 2.21172 0.445312 2.93243 0.445312C3.64029 0.445312 4.21299 0.65122 4.65058 1.06307C5.10102 1.48778 5.32625 2.04118 5.32625 2.7233C5.32625 3.34107 5.10747 3.85585 4.66988 4.26771C4.21944 4.69242 3.62741 4.90477 2.89382 4.90477H2.87452C2.16666 4.90477 1.59396 4.69242 1.15637 4.26771C0.718784 3.843 0.5 3.30888 0.5 2.66539ZM0.750965 19.5573V6.66153H5.03668V19.5573H0.750965ZM7.4112 19.5573H11.6969V12.3565C11.6969 11.906 11.7484 11.5586 11.8514 11.314C12.0315 10.8765 12.305 10.5064 12.6718 10.204C13.0386 9.90155 13.4987 9.75033 14.0521 9.75033C15.4936 9.75033 16.2143 10.722 16.2143 12.6654V19.5573H20.5V12.1635C20.5 10.2587 20.0496 8.81404 19.1486 7.82948C18.2477 6.84493 17.0573 6.35265 15.5772 6.35265C13.917 6.35265 12.6236 7.06693 11.6969 8.49551V8.53412H11.6776L11.6969 8.49551V6.66153H7.4112C7.43693 7.07336 7.44981 8.35392 7.44981 10.5032C7.44981 12.6525 7.43693 15.6705 7.4112 19.5573Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10392_3950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.112,
    fill: "white",
    transform: "translate(0.5 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.f0084f0ab1bf13feec279039ae80bcf3.svg";
export { ForwardRef as ReactComponent };